import React from 'react';
import { Space } from 'antd';
import SocialMedia from '../SocialMedia/SocialMedia';
import { SocialMediaSize } from '../SocialMedia/SocialMedia.types';
import { spaceStyle } from './KimeraWareSocialMedia.styles';

const KimeraWareSocialMedia: React.FC<{ size?: SocialMediaSize }> = React.memo(
  ({ size = 'large' }) => {
    return (
      <Space size={128} wrap style={spaceStyle}>
        <SocialMedia platform="youtube" size={size} url="https://www.youtube.com/@Kimeraware" />
        <SocialMedia platform="twitter" size={size} url="https://twitter.com/KimeraWare" />
        <SocialMedia platform="instagram" size={size} url="https://www.instagram.com/kimeraware/" />
      </Space>
    );
  },
);

KimeraWareSocialMedia.displayName = 'KimeraWareSocialMedia';

export default KimeraWareSocialMedia;
